const formatSsaRole = (roleString) => {
  if (!roleString || typeof roleString !== 'string') {
    return '';
  }

  // Special case for ssa_casemanager
  if (roleString === 'ssa_casemanager') {
    return 'Case Manager';
  }

  // Remove "ssa_" prefix if it exists
  const withoutPrefix = roleString.replace(/^ssa_/, '');

  // Replace underscores with spaces and capitalize each word
  return withoutPrefix
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export default formatSsaRole;